import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetCardBuilderComponent } from './widget-card-builder/widget-card-builder.component';
import { CustomFieldPreviewComponent } from './widget-card-builder/custom-field-preview/custom-field-preview.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatChipsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule
  ],
  exports: [WidgetCardBuilderComponent],
  declarations: [WidgetCardBuilderComponent, CustomFieldPreviewComponent],
  providers: [],
})
export class WidgetConfigPreviewModule {}
